import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import Layout from "@/views/layout/index.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/system',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '数据概览', icon: 'el-icon-s-home' }
      }
    ]
  },


  {
    path: '/coupon',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/coupon/coupon',
    children: [
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/coupon/coupon.vue'),
        meta: { title: '优惠券管理', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/writeCoupon',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/writeCoupon/writeCoupon',
    children: [
      {
        path: 'writeCoupon',
        name: 'writeCoupon',
        component: () => import('@/views/writeCoupon/writeCoupon.vue'),
        meta: { title: '核销', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/writeCouponRecord',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/writeCouponRecord/writeCouponRecord',
    children: [
      {
        path: 'writeCouponRecord',
        name: 'writeCouponRecord',
        component: () => import('@/views/writeCouponRecord/writeCouponRecord.vue'),
        meta: { title: '核销记录', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/claim',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/claim/claim',
    children: [
      {
        path: 'claim',
        name: 'claim',
        component: () => import('@/views/claim/coupon.vue'),
        meta: { title: '领取记录', icon: 'el-icon-s-home' }
      }
    ]
  },



  {
    path: '/system',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/system/admin',
    meta: { title: '系统管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/admin/index.vue'),
        meta: { title: '管理员列表', icon: 'el-icon-user' }
      },
      {
        path: 'role',
        name: 'Role',
        component: () => import('@/views/role/index.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'menu',
        name: 'Menu',
        component: () => import('@/views/menu/index.vue'),
        meta: { title: '菜单管理', icon: 'el-icon-menu' }
      }
    ]
  },


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.path === '/login') {
    next()
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
